export default {
  checklistItemTransactions: [],
  checklistItemTransaction: undefined,
};
